import React from 'react';
import ReactDOM from 'react-dom';
import Terms from './terms_and_conditions';

ReactDOM.render(<Terms />, document.getElementById('content'));



// WEBPACK FOOTER //
// ./brand/terms_and_conditions/index.js